import React, { useEffect } from "react"
import { Container, Typography, CardMedia, Button } from "@mui/material"
import { Link as RouterLink, useNavigate } from "react-router-dom"
import { useAuthUser, useIsAuthenticated } from "react-auth-kit"

function HomePage() {
  const isAuthenticated = useIsAuthenticated()
  const auth = useAuthUser()
  const navigate = useNavigate()

  const renderButton = (label: string, path: string) => (
    <Button
      component={RouterLink}
      to={path}
      variant="contained"
      color="primary"
      size="large"
      style={{ margin: "20px", textDecoration: "none" }}
    >
      {label}
    </Button>
  )

  useEffect(() => {
    const type = auth()?.type

    if (isAuthenticated()) {
      if (type === "voter") {
        navigate("/voter/dashboard")
      } else {
        navigate("/admin/dashboard")
      }
    }
  }, [isAuthenticated, auth, navigate])

  const VoterLoginButton = () => renderButton("Voter Login", "/voter/login")
  const AdminLoginButton = () => renderButton("Admin Login", "/admin/login")

  const name = auth()?.name
  const type = auth()?.type

  return (
    <Container>
      <Typography variant="h5" align="center" m={4}>
        Welcome To Member Voting
      </Typography>
      {isAuthenticated() && (
        <Typography variant="h6" align="center" m={4}>
          {`${name} (${type})`}
        </Typography>
      )}

      {isAuthenticated() ? (
        <></>
      ) : (
        <>
          <VoterLoginButton />
          <AdminLoginButton />
        </>
      )}
      <CardMedia
        component="img"
        style={{ height: "500px" }}
        image="/adminvote.jpg"
        alt="Admin"
      />
    </Container>
  )
}

export default HomePage
